import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DashboardGlobalService } from "../../core/service/dashboard-global.service";

import * as Highcharts from "highcharts";
import { QuantiteDossierPortefeuilleDTO } from "../../core/model/quantite-dossier-portefeuille-dto";
import { DashboardSyntheseNbrDossierPeriode } from "../../core/model/dashboard-synthese-nbr-dossier-periode";
import { DashboardSyntheseMontantDossierPeriode } from "../../core/model/dashboard-synthese-montant-dossier-periode";
import { DashboardService } from "../../core/service/dashboard.service";
import { Router } from '@angular/router';
import { Moment } from "moment";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { UserService } from "src/app/shared/directives/user.service";

@Component({
  selector: "app-global-portefeuille",
  templateUrl: "./global-portefeuille.component.html",
  styleUrls: ["./global-portefeuille.component.scss"],
})
export class GlobalPortefeuilleComponent implements OnInit {
  selectedDate: { startDate: Moment; endDate: Moment };
  startDate: String = null;
  endDate: String = null;

  MyPermissions: string[];
  private userPermission = {
    permissions: [],
  };

  corporatePortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  particulierPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  professionnelPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  productProgramPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();

  nombreDossier: DashboardSyntheseNbrDossierPeriode[];
  montantDemande: DashboardSyntheseMontantDossierPeriode[];
  montantAccorde: DashboardSyntheseMontantDossierPeriode[];
  montantMiseEnPlace: DashboardSyntheseMontantDossierPeriode[];

  highcharts1 = Highcharts;
  chartOptions1: any;

  highcharts2 = Highcharts;
  chartOptions2: any;

  highcharts3 = Highcharts;
  chartOptions3: any;

  highcharts4 = Highcharts;
  chartOptions4: any;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _dashboardGlobalService: DashboardGlobalService,
    private _keycloakService: KeycloakService,
    private userService: UserService,
        
    
    private _dashboardService: DashboardService
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }

  ngOnInit() {
    this.quantiteDossierPortefeuilleCorporate();
    this.quantiteDossierPortefeuilleParticulier();
    this.quantiteDossierPortefeuilleProfessionnel();
    this.quantiteDossierPortefeuilleProductProgram();
    this.syntheseNombreDossierCreeFiltrerSurPeriode();
    this.syntheseMontantDemandeDossierEncoursFiltrerSurPeriode();
    this.syntheseMontantAccordeDossierEncoursFiltrerSurPeriode();
    this.syntheseMontantMiseenplaceDossierEncoursFiltrerSurPeriode();
  }

  changeRange(event) {
    this.startDate = this.selectedDate.startDate.format("YYYY-MM-DD HH:mm:ss");
    this.endDate = this.selectedDate.endDate.format("YYYY-MM-DD HH:mm:ss");

    this.quantiteDossierPortefeuilleCorporate();
    this.quantiteDossierPortefeuilleParticulier();
    this.quantiteDossierPortefeuilleProfessionnel();
    this.quantiteDossierPortefeuilleProductProgram();
    this.syntheseNombreDossierCreeFiltrerSurPeriode();
    this.syntheseMontantDemandeDossierEncoursFiltrerSurPeriode();
    this.syntheseMontantAccordeDossierEncoursFiltrerSurPeriode();
    this.syntheseMontantMiseenplaceDossierEncoursFiltrerSurPeriode();
  }

  quantiteDossierPortefeuilleCorporate() {
    this._dashboardGlobalService
      .quantiteDossierPortefeuille("CORPORATE", this.startDate, this.endDate)
      .pipe(first())
      .subscribe(
        (data) => {
          this.corporatePortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleParticulier() {
    this._dashboardGlobalService
      .quantiteDossierPortefeuille("PARTICULIER", this.startDate, this.endDate)
      .pipe(first())
      .subscribe(
        (data) => {
          this.particulierPortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleProfessionnel() {
    this._dashboardGlobalService
      .quantiteDossierPortefeuille(
        "PROFESSIONNEL",
        this.startDate,
        this.endDate
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.professionnelPortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleProductProgram() {
    this._dashboardGlobalService
      .quantiteDossierPortefeuille(
        "PRODUCT_PROGRAM",
        this.startDate,
        this.endDate
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.productProgramPortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }


  

  syntheseNombreDossierCreeFiltrerSurPeriode() {
    this._dashboardService
      .syntheseNombreDossierEncoursFiltrerSurPeriode()
      .pipe(first())
      .subscribe(
        (data) => {
          this.nombreDossier = data;

          const yearMonth: String[] = [];
          const corporate: number[] = [];
          const particulier: number[] = [];
          const professionnel: number[] = [];
          this.nombreDossier.forEach(function (value) {
            yearMonth.push(value.year + "-" + value.month);
            corporate.push(value.encours_corporate);
            particulier.push(value.encours_particulier);
            professionnel.push(value.encours_professionnel);
          });

          this.chartOptions1 = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Dossiers de crédit créés sur les 12 derniers mois",
            },
            xAxis: {
              categories: yearMonth,
            },
            yAxis: {
              title: {
                text: "Quantité",
              },
            },
            tooltip: {
              valueSuffix: " dossier(s)",
            },
            series: [
              {
                name: "corporate",
                data: corporate,
                color: "rgb(255, 152, 0)",
              },
              {
                name: "particulier",
                data: particulier,
                color: "rgb(34, 139, 34)",
              },
              {
                name: "professionnel",
                data: professionnel,
                color: "black",
              },
            ],
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  syntheseMontantDemandeDossierEncoursFiltrerSurPeriode() {
    this._dashboardService
      .syntheseMontantDemandeDossierEncoursFiltrerSurPeriode()
      .pipe(first())
      .subscribe(
        (data) => {
          this.montantDemande = data;

          const yearMonth: String[] = [];
          const corporate: number[] = [];
          const particulier: number[] = [];
          const professionnel: number[] = [];
          this.montantDemande.forEach(function (value) {
            yearMonth.push(value.year + "-" + value.month);
            corporate.push(value.montant_corporate);
            particulier.push(value.montant_particulier);
            professionnel.push(value.montant_professionnel);
          });

          this.chartOptions2 = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Montants demandés sur les 12 derniers mois",
            },
            xAxis: {
              categories: yearMonth,
            },
            yAxis: {
              title: {
                text: "Montant(xof)",
              },
            },
            tooltip: {
              valueSuffix: " xof",
            },
            series: [
              {
                name: "corporate",
                data: corporate,
                color: "rgb(255, 152, 0)",
              },
              {
                name: "particulier",
                data: particulier,
                color: "rgb(34, 139, 34)",
              },
              {
                name: "professionnel",
                data: professionnel,
                color: "black",
              },
            ],
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  syntheseMontantAccordeDossierEncoursFiltrerSurPeriode() {
    this._dashboardService
      .syntheseMontantAccordeDossierEncoursFiltrerSurPeriode()
      .pipe(first())
      .subscribe(
        (data) => {
          this.montantAccorde = data;

          const yearMonth: String[] = [];
          const corporate: number[] = [];
          const particulier: number[] = [];
          const professionnel: number[] = [];
          this.montantAccorde.forEach(function (value) {
            yearMonth.push(value.year + "-" + value.month);
            corporate.push(value.montant_corporate);
            particulier.push(value.montant_particulier);
            professionnel.push(value.montant_professionnel);
          });

          this.chartOptions3 = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Montants accordés sur les 12 derniers mois",
            },
            xAxis: {
              categories: yearMonth,
            },
            yAxis: {
              title: {
                text: "Montant(xof)",
              },
            },
            tooltip: {
              valueSuffix: " xof",
            },
            series: [
              {
                name: "corporate",
                data: corporate,
                color: "rgb(255, 152, 0)",
              },
              {
                name: "particulier",
                data: particulier,
                color: "rgb(34, 139, 34)",
              },
              {
                name: "professionnel",
                data: professionnel,
                color: "black",
              },
            ],
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  syntheseMontantMiseenplaceDossierEncoursFiltrerSurPeriode() {
    this._dashboardService
      .syntheseMontantMiseenplaceDossierEncoursFiltrerSurPeriode()
      .pipe(first())
      .subscribe(
        (data) => {
          this.montantMiseEnPlace = data;

          const yearMonth: String[] = [];
          const corporate: number[] = [];
          const particulier: number[] = [];
          const professionnel: number[] = [];
          this.montantMiseEnPlace.forEach(function (value) {
            yearMonth.push(value.year + "-" + value.month);
            corporate.push(value.montant_corporate);
            particulier.push(value.montant_particulier);
            professionnel.push(value.montant_professionnel);
          });

          this.chartOptions4 = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Montants mis en place sur les 12 derniers mois",
            },
            xAxis: {
              categories: yearMonth,
            },
            yAxis: {
              title: {
                text: "Montant(xof)",
              },
            },
            tooltip: {
              valueSuffix: " xof",
            },
            series: [
              {
                name: "corporate",
                data: corporate,
                color: "rgb(255, 152, 0)",
              },
              {
                name: "particulier",
                data: particulier,
                color: "rgb(34, 139, 34)",
              },
              {
                name: "professionnel",
                data: professionnel,
                color: "black",
              },
            ],
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  redirectUrl(baseUrl: string, states: string[]): void {
    const encodedStates = encodeURIComponent(JSON.stringify(states)); // Convertir en JSON et encoder
    const url =
      `${baseUrl}${encodedStates}` + "/" + this.startDate + "/" + this.endDate;

    console.log(url); // Vérifiez l'URL générée
    this._router.navigate([url]).then((success) => {
      if (success) {
      } else {
        console.error("Navigation to", url, "failed.");
      }
    });
  }
}
